module.exports = __webpack_public_path__ + "signature.98f2011.png";